'use strict';

var React = require('react');
var FeesPage = require('./../../components/common/FeesPage.react');
var GriffinNumber = require('griffin-paypal/number');

var RootComponent = React.createClass({
    propTypes: {
        renderCurrentPage: React.PropTypes.func.isRequired,
        griffinMetadata: React.PropTypes.object.isRequired,
        section: React.PropTypes.string,
        dailyLimit: React.PropTypes.string.isRequired,
        monthlyLimit: React.PropTypes.string.isRequired,
        isCFPBCardPlusContentFlagEnabled: React.PropTypes.bool,
        instanceLocation: React.PropTypes.object.isRequired,
        remoteConfig: React.PropTypes.object.isRequired
    },

    render: function() {
        var griffin = {
            griffinNumber: GriffinNumber.createHandler(this.props.griffinMetadata)
        };

        return this.props.renderCurrentPage({
            section: this.props.section,
            griffin: griffin,
            dailyLimit: this.props.dailyLimit,
            monthlyLimit: this.props.monthlyLimit,
            isCFPBCardPlusContentFlagEnabled: this.props.isCFPBCardPlusContentFlagEnabled,
            instanceLocation: this.props.instanceLocation,
            remoteConfig: this.props.remoteConfig
        });
    }
});

RootComponent.getFlowProps = function() {
    return {
        startPage: FeesPage,
        terminalPages: [FeesPage],
        hideFeedbackLink: [FeesPage]
    };
};

module.exports = RootComponent;



/** WEBPACK FOOTER **
 ** ./public/js/apps/fees/RootComponent.react.js
 **/